// extracted by mini-css-extract-plugin
export default {"popper":"BAnalysisChartSettingButton-module_popper_cf3e732c","popperContent":"BAnalysisChartSettingButton-module_popperContent_f3b6ccee"};